import { Link } from 'react-router-dom';
import { useAuth } from '../app/providers.js';
import { supabaseConfigured } from '../app/env.js';

export function Home() {
  const { state, capabilities } = useAuth();

  return (
    <section>
      <h1 className="ph-screen__title">PlatHunt</h1>
      <p className="ph-screen__note">Trophäen. Roadmaps. 100 %.</p>

      <div className="ph-card">
        <Link className="ph-row" to="/games">
          Spiele
        </Link>
        <Link className="ph-row" to="/search">
          Suche
        </Link>
        <Link className="ph-row" to="/settings">
          Einstellungen
        </Link>
      </div>

      <div className="ph-card">
        <p className="ph-muted">
          Zustand: {state.kind === 'guest' ? 'Gast' : state.kind}
          {' · '}
          Fortschritt: {capabilities.cloudSync ? 'Cloud' : 'lokal'}
          {' · '}
          Trophy-Sync: {capabilities.trophySync ? 'aktiv' : 'aus'}
        </p>
        <p className="ph-muted">
          Datenquelle: {supabaseConfigured ? 'Supabase' : 'DEV FIXTURES (keine echten Spieldaten)'}
        </p>
      </div>
    </section>
  );
}
